import type { ReactNode } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';

type Props = {
  children: ReactNode;
};

const SiteLayout = ({ children }: Props) => (
  <div className="flex min-h-screen flex-col bg-background-50">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <BackToTop />
  </div>
);

export default SiteLayout;